<template>
<div class="bd-example">
   <div class="modeltheme-modal modeltheme-show" id="modal-log-in">
      <div class="modeltheme-content" id="login-modal-content" style="display: block;">
         <img src="@/assets/images/logo.svg" style="width: 200px;">
         <div class="modal-content row">
            <div class="col-md-12" v-if="mode==0">
               <form name="loginform" id="loginform" onSubmit="return false;">
                  <p class="login-username">
                     <label for="user_login">Tên Đăng Nhập</label>
                     <i class="fa fa-user-o" aria-hidden="true"></i>
                     <input type="text" v-model="username" name="log" id="user_login" class="input" value="" required="" size="20" placeholder="Tên đăng nhập" aria-required="true">
                  </p>
                  <p class="login-password">
                     <label for="user_pass">Mật Khẩu</label>
                     <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                     <input type="password" v-model="password"  name="pwd" id="user_pass" class="input" value="" required="" size="20" placeholder="Mật khẩu" aria-required="true">
                  </p>
                  <div class="row-buttons">
                     <p class="login-submit">
                        <input type="submit" v-on:click="login" class="button button-primary" value="Đăng Nhập">
                     </p>
                     <p class="woocommerce-LostPassword lost_password">
                        <a v-on:click="mode=1">Quên Mật Khẩu?</a>
                     </p>
                  </div>
               </form>
            </div>
            <div class="col-md-12" v-else>
               <form name="loginform" id="loginform" onSubmit="return false;">
                  <p class="login-username">
                     <label for="user_login">Email</label>
                     <i class="fa fa-user-o" aria-hidden="true"></i>
                     <input type="text" v-model="email" name="log" id="user_login" class="input" value=""  size="20" placeholder="Email" aria-required="true">
                     <code v-if="status==1">Email không được để trống</code>
                     <span v-else-if="status==2">Chúng tôi đã gửi mật khẩu về email của Quý khách. Vui lòng kiểm tra!</span>
                  </p>
                  <div class="row-buttons">
                     <p class="login-submit">
                        <input type="submit" v-on:click="resetPassword" class="button button-primary" value="Gửi">
                     </p>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import User from "@/common/api/user"
import {saveToken, saveInfo} from "@/common/jwt"
import { LOGIN, SET_AUTH } from "@/store/actions.type";
export default {
  name: 'Login',
  mixins: [mixin],
  data () {
    return {
       status: 0,
       mode: 0,
       username: '',
       password: '',
       email: '',
    }
  },
  methods: {
     resetPassword(){
        if (this.email == ''){
           this.status = 1;
           return;
        }
        User.resetPassword(this.email)
        .then(({ data }) => {
           this.status = 2
        })
     },
     login(){
        User.login(this.username, this.password)
        .then(({ data }) => {
           if(data.Data){
            saveInfo({id: data.Data.id, username:this.username})
            saveToken(data.Data.token,data.Data.refresh_token)
            // this.$store.dispatch(SET_AUTH, {id: data.Data.id, username:this.username})
            this.$modal.hide('modal-login');
            this.reloadUrl()
           }
        })
     }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue